import React, { useEffect, useRef, useState } from 'react';

import { PJAxios, sendLogin, setLanguage, useLanguage, usePJStore, useUserInfo } from '@jaf/jaf-react-core';
import moment from 'moment/moment';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Chip } from 'primereact/chip';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { DataView } from 'primereact/dataview';
import { Divider } from 'primereact/divider';
import { ProgressSpinner } from 'primereact/progressspinner';
import './Chatbot.css';
import BackArrow from './ChatbotComponents/BackArrow';
import BackBottomButton from './ChatbotComponents/BackBottomButton';
import ContactChannels from './ChatbotComponents/ContactChannels';
import SearchBox from './ChatbotComponents/SearchBox';

import { Accordion, AccordionTab } from 'primereact/accordion';
import './ChatbotRestyled.css';
import { PJButton } from '@it-polimi/pj-react-ui';
import { Toast } from 'primereact/toast';

import { Buffer } from 'buffer';
import { sha256 } from 'js-sha256';


function ChatbotRestyled(props) {

    const isLogged = useUserInfo() != null;
    const params = usePJStore((state) => state.params)
    const language = useLanguage();
    const codice_persona = usePJStore((state) => state.userInfo_codice_persona)
    const toast = useRef(null);

    const [redirectPath, setRedirectPath] = useState(sessionStorage.getItem("postLoginRedirect"));
    const [storedMenu, setStoredMenu] = useState(sessionStorage.getItem("selectedMenu"));
    const [storedArgument, setStoredArgument] = useState(sessionStorage.getItem("selectedArgument"));


    useEffect(() => {
        setStoredArgument(sessionStorage.getItem("selectedArgument"));
    }, [sessionStorage.getItem("selectedArgument")]);

    useEffect(() => {
        setStoredMenu(sessionStorage.getItem("selectedMenu"));
    }, [sessionStorage.getItem("selectedMenu")]);

    useEffect(() => {
        setRedirectPath(sessionStorage.getItem("postLoginRedirect"));
    }, [sessionStorage.getItem("postLoginRedirect")]);
    //internazionalizzazione
    const getText = usePJStore((state) => state.i18n_getText)

    const [infoMessages, setInfoMessages] = useState([])

    //variabile dove viene depositato l'albero "corrente" - tematica principale o sottotematica
    const [albero, setAlbero] = useState([]);

    //cache dell'albero root - 48, per evitare chiamata al backend quando si torna alla root
    const [alberoRoot, setAlberoRoot] = useState([]);

    //valore della searchbox
    const [searchText, setSearchText] = useState("");

    //elenco delle tematiche
    const [menus, setMenus] = useState([]);

    //elenco degli argomenti (si popola alla selezione della tematica)
    const [argumentz, setArgumentz] = useState([]);

    //elenco delle faq (si popola alla selezione dell'argomento)
    const [faqs, setFaqs] = useState(null);

    //è il risultato filtrato di tutte le faq con il criterio di ricerca applicato
    const [faqResults, setFaqResults] = useState(null);

    //sono gli id delle faqs delle sottotematiche dell'albero principale 
    //(da utilizzare perchè l'albero FAQ caricato in startup le contiene tutte, anche quelle che non dovrebbero essere visibili)
    const [faqIds, setFaqIds] = useState([]);

    //tematica selezionata
    const [selectedMenu, setSelectedMenu] = useState(null);

    //ultima tematica selezionata
    const [previousMenu, setPreviousMenu] = useState(null);


    //argomento selezionato
    const [selectedArgument, setSelectedArgument] = useState(props.selectedArgument ? props.selectedArgument : null);

    //ultimo argomento selezionato
    const [previousArgument, setPreviousArgument] = useState(null);

    //faq selezionata
    const [selectedFaq, setSelectedFaq] = useState(null);

    //contiene info aggiuntive (le tematiche in cui è inclusa una faq)
    const [faqDetail, setFaqDetail] = useState(null);

    const [languageSelected, setLanguageSelected] = useState(false);

    const [idParent, setIdParent] = useState(null);

    //livello di navigazione, può essere:
    //root: inizio della navigazione, devi ancora scegliere una tematica
    //menu: tematica selezionata, devi scegliere l'argomento
    //faq: argomento scelto, devi scegliere la faq
    //faqDetail: faq scelta da albero, ne vedi il dettaglio
    //faqSearch: faq scelta da ricerca, ne vedi il dettaglio
    const [level, setLevel] = useState("root")

    const [eventi, setEventi] = useState([]);
    const [eventoDiChiusura, setEventoDiChiusura] = useState(null);
    const [eventoDiInformazione, setEventoDiInformazione] = useState(null);
    const [showHolidayDialog, setShowHolidayDialog] = useState(false)

    //oggetto di transito (utile per creare questions)
    const [autoCompleteFaqs, setAutoCompleteFaqs] = useState(null);

    //elenco faq che vengono filtrate quando si ricerca. rispetto a faqs cambia la struttura del dato
    const [questions, setQuestions] = useState([]);

    //struttura che contiene i possibili agganci col mondo esterno - liveHelp, sidera
    const [channels, setChannels] = useState(null)


    //elenco soli canali sidera
    const [sideraMenu, setSideraMenu] = useState([])

    //id della conversazione, viene staccato quando si entra in pagina
    const [conversationId, setConversationId] = useState(null)

    //variabile per identificare il caricamento in corso e mostrare spinner
    const [loading, setLoading] = useState(false);

    //contatore che serve per triggerare subcomponent (per sbiancare il testo della searchbox)
    const [textChangeTrigger, setTextChangeTrigger] = useState(0);

    //contatore che serve per triggerare subcomponent (per sbiancare il testo della searchbox)
    const [clearTextTrigger, setClearTextTrigger] = useState(0);

    const [dests, setDests] = useState([])

    //flag che serve per chiudere creazione ticket nel caso di festività
    const [otoboEnabled, setOtoboEnabled] = useState(true);

    //flag che serve per abilitare il login preventivo all'apertura del ticket
    const [loginEnabled, setLoginEnabled] = useState(true);

    const [idConfig, setIdConfig] = useState(null)

    const [emptyResultSearch, setEmptyResultSearch] = useState(null)

    const [externalSources, setExternalSources] = useState([]);

    const [sottoTematiche, setSottoTematiche] = useState(null);

    const [tematicheNoChat, setTematicheNoChat] = useState(null)


    const getNome = (selectedNode) => {
        return selectedNode.bundle != null ? selectedNode.bundle : selectedNode.question;
    };

    const getDescrizione = (selectedNode) => {
        return selectedNode.descrizione != null ? selectedNode.descrizione : "";
    };

    const getQuantitaDomande = (selectedNode) => {
        return selectedNode.countFaq != null ? selectedNode.countFaq : 0;
    };

    const getConventionalAnswer = (selectedNode) => {
        return selectedNode.answer;
    };

    /**
     * funzione di ricerca per filtrare le faq
     * @param {*} query 
     */
    const searchNode = (query) => {
        try {
            setTimeout(() => {
                var ret = [];
                const words = query.toLowerCase().split(" ");
                ret = ricercaInversa(query.toLowerCase());
                setFaqResults(ret);

                setSelectedArgument(null)
                setSelectedMenu(null)
            }, 250);
        } catch (exception) {
            console.error("Error in searchNode:", exception);
        }
    }

    function evidenziaParola(words, inputParola) {
        try {
            let parola = inputParola;
            if (!words || !parola) return words;

            // Regex che preserva spazi e ignora le parole già evidenziate
            const regex = new RegExp(`(\\s*)(?!<[^>]*>)(\\b${parola}\\b)(?![^<]*>)(\\s*)`, 'gi');

            const result = words.replace(regex, (match, spazioPrima, parolaTrovata, spazioDopo) => {
                return `${spazioPrima}<div class='highlight'>${parolaTrovata}</div>${spazioDopo}`;
            });

            // Aggiungi uno spazio non interrotto esplicito se necessario tra due div consecutivi
            return result.replace(/<\/div>\s+<div/g, '</div>&nbsp;<div');
        } catch (error) {
            console.error("Error in evidenziaParola:", error);
            return words;
        }
    }


    const ricercaInversa = (words) => {
        try {
            var ret = [];
            let counterLivello = 0;

            let parole = words.trimEnd().split(" ");
            let parola = words.trimEnd();

            questions.forEach((node) => {

                let livelloMax = parole.length;

                let question = null;
                if (parola.includes(" ") || parola.length > 2) {
                    if (getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(parola) !== -1) {
                        if (faqIds != null && faqIds.length > 0 && faqIds.includes(node.data.elemento_id)) {
                            let bundle = getText(node.data.elemento.extra_fields.bundle);
                            let question = {
                                question: node.data.elemento.extra_fields.bundle,
                                answer: node.data.elemento.extra_fields.bundle.replace(":QUESTION", ":ANSWER"),
                                idItem: node.data.elemento.extra_fields.id_item,
                                idNode: node.data.elemento.elemento_id,
                                label: bundle,
                                value: node.value,
                                icon: node.icons,
                                data: node.data
                            }
                            ret.push(question);

                        }
                    }
                    else {
                        let counterParole = 0;
                        let bundle = getText(node.data.elemento.extra_fields.bundle);
                        parole.forEach((divise) => {

                            if (getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(divise) !== -1) {
                                counterParole++;
                                bundle = evidenziaParola(bundle, divise);
                            }
                            if (counterParole === livelloMax) {
                                let question = {
                                    question: node.data.elemento.extra_fields.bundle,
                                    answer: node.data.elemento.extra_fields.bundle.replace(":QUESTION", ":ANSWER"),
                                    idItem: node.data.elemento.extra_fields.id_item,
                                    idNode: node.data.elemento.elemento_id,
                                    label: bundle,
                                    value: node.value,
                                    icon: node.icons,
                                    data: node.data
                                }
                                ret.push(question);

                            }
                        })
                    }
                } else if (getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(parola) !== -1) {
                    if (getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(" " + parola + " ") !== -1) {
                        if (faqIds != null && faqIds.length > 0 && faqIds.includes(node.data.elemento_id)) {
                            let question = {
                                question: node.data.elemento.extra_fields.bundle,
                                answer: node.data.elemento.extra_fields.bundle.replace(":QUESTION", ":ANSWER"),
                                idItem: node.data.elemento.extra_fields.id_item,
                                idNode: node.data.elemento.elemento_id,
                                label: evidenziaParola(getText(node.data.elemento.extra_fields.bundle), parola),
                                value: node.value,
                                icon: node.icons,
                                data: node.data
                            }
                            ret.push(question);

                        }
                    } else if (getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(parola + " ") === 0) {
                        if (faqIds != null && faqIds.length > 0 && faqIds.includes(node.data.elemento_id)) {
                            question = {
                                question: node.data.elemento.extra_fields.bundle,
                                answer: node.data.elemento.extra_fields.bundle.replace(":QUESTION", ":ANSWER"),
                                idItem: node.data.elemento.extra_fields.id_item,
                                idNode: node.data.elemento.elemento_id,
                                label: evidenziaParola(getText(node.data.elemento.extra_fields.bundle), parola),
                                value: node.value,
                                icon: node.icons,
                                data: node.data
                            }
                            ret.push(question);

                        }
                    } else if (getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(" " + parola + "?") !== -1
                        || getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(" " + parola + ".") !== -1
                        || getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(" " + parola) !== -1 && getText(node.data.elemento.extra_fields.bundle).toLowerCase().indexOf(" " + parola) === getText(node.data.elemento.extra_fields.bundle).toLowerCase().length - (" " + parola).length) {
                        if (faqIds != null && faqIds.length > 0 && faqIds.includes(node.data.elemento_id)) {
                            question = {
                                question: node.data.elemento.extra_fields.bundle,
                                answer: node.data.elemento.extra_fields.bundle.replace(":QUESTION", ":ANSWER"),
                                idItem: node.data.elemento.extra_fields.id_item,
                                idNode: node.data.elemento.elemento_id,
                                label: evidenziaParola(getText(node.data.elemento.extra_fields.bundle), parola),
                                value: node.value,
                                icon: node.icons,
                                data: node.data
                            }
                            ret.push(question);

                        }
                    }
                }
            })
            return ret;
        } catch (error) {
            console.error("Error in ricercaInversa:", error);
            return [];
        }
    }

    useEffect(() => {
        try {
            // ricerche vuote
            if (faqResults == null || faqResults.length == 0) {
                if (emptyResultSearch == null || searchText.toLowerCase().includes(emptyResultSearch)) {
                    setEmptyResultSearch(searchText.toLowerCase());
                }
            }

            setOtoboEnabled(eventoDiChiusura == null && faqResults != null && faqResults.length > 0);
        } catch (error) {
            console.error("Error in useEffect faqResults:", error);
        }
    }, [faqResults]);

    useEffect(() => {
        try {
            if (level == "root") {
                setEventi([]);
                setShowHolidayDialog(false);

                setSelectedMenu(null);
                setSelectedArgument(null);
                setArgumentz(null);
                setPreviousArgument(null);
                setPreviousMenu(null);
                setIdParent(null);
                setSearchText('');
            }
            if (level != "faq") {
                setChannels(null);
            }
        } catch (error) {
            console.error("Error in useEffect level:", error);
        }
    }, [level]);

    useEffect(() => {
        try {
            if (eventoDiChiusura != null || eventoDiInformazione != null) {
                setShowHolidayDialog(true);
            }
        } catch (error) {
            console.error("Error in useEffect evento di chiusura:", error);
        }
    }, [eventoDiChiusura, eventoDiInformazione]);

    useEffect(() => {
        try {
            if (conversationId != null) {
                beginConversation(conversationId, codice_persona, language);
            }
        } catch (error) {
            console.error("Error in useEffect conversationId:", error);
        }
    }, [conversationId]);


    useEffect(() => {
        try {
            if (language != null) {
                createNewConversation();
            }
        } catch (error) {
            console.error("Error in useEffect language:", error);
        }
    }, [language]);


    useEffect(() => {

        try {
            if (selectedArgument != null) {
                getExternalContactLinks(selectedArgument.idNode);
                setLevel("faq");
                caricaFaqs(selectedArgument.idNode);
                caricaDest(selectedArgument.idNode);
                addRigaConversation(conversationId, searchText, selectedMenu.idItem, selectedArgument.idItem, null, null);
                loadExternalSources(selectedArgument.idItem, null);
                setIdParent(null);
                //SET MENU FLAG LOGIN
                setPreviousArgument(selectedArgument);
            }
        } catch (error) {
            console.error("Error in useEffect selectedArgument:", error);
        }
    }, [selectedArgument]);



    useEffect(() => {
        try {
            console.log("searchText changed:", searchText);
            if (searchText != null && searchText.length > 0) {
                setLevel("faqSearch");
                searchNode(searchText);
            } else {
                setLevel("root");
                setClearTextTrigger(clearTextTrigger + 1);
            }
        } catch (error) {
            console.error("Error in useEffect searchText:", error);
        }
    }, [searchText]);

    useEffect(() => {
        try {
            let questions = [];

            if (autoCompleteFaqs != null) {
                autoCompleteFaqs[0].children.forEach((faq) => {
                    if (faq.icon === "pi pi-question-circle") {
                        if (faq.data.elemento.extra_fields.numero_istanze > 0) {
                            let question = {
                                value: faq.key,
                                label: "" + faq.label,
                                icon: faq.icon,
                                data: faq.data
                            };
                            questions.push(question);
                        }
                    } else if (faq.icon === "pi pi-folder") {
                        faq.children.forEach((inner) => {
                            if (inner.icon === "pi pi-question-circle") {
                                if (inner.data.elemento.extra_fields.numero_istanze > 0) {
                                    let question = {
                                        value: inner.key,
                                        label: inner.label,
                                        icon: inner.icon,
                                        data: inner.data
                                    };
                                    questions.push(question);
                                }
                            }
                        });
                    }
                });
            }
            setQuestions(questions);
        } catch (error) {
            console.error("Error in useEffect autoCompleteFaqs:", error);
        }
    }, [autoCompleteFaqs]);

    useEffect(() => {
        try {
            var items = [];
            if (albero == null || albero.struttura == null) {
                return;
            } else {

                albero.struttura.map((item) => {
                    if (item.elemento_padre_id == 0 && isNodeVisible(item)) {
                        items.push(item);
                    }
                    if (level == 'root') {
                        if (sottoTematiche == null) {
                            var ret = [];
                            albero.listaCompletaFoglie.forEach((foglia) => {
                                if (foglia.elemento.extra_fields.type == 'L') {
                                    ret.push({
                                        id_config: foglia.elemento.extra_fields.tema_collegato.split(" - ")[0],
                                        titolo: foglia.elemento.extra_fields.titolo,
                                        descrizione: foglia.elemento.extra_fields.descrizione,
                                        quantita: foglia.elemento.extra_fields.quantita,
                                    });
                                }
                                setSottoTematiche(ret);
                            });
                        }
                    }



                });
            }
        } catch (error) {
            console.error("Error in useEffect albero:", error);
        }
    }, [albero]);

    useEffect(() => {

        if (idConfig != null) {
            caricaConfigurazioni(idConfig, "root")
        }

    }, [idConfig]);

    /**
     * funzione che serve per capire se un nodo è configurato come "visibile"
     * @param {*} selectedNode 
     * @returns 
     */
    const isNodeVisible = (selectedNode) => {
        return (selectedNode.elemento.extra_fields.nascondifaq === "N" || selectedNode.elemento.extra_fields.nascondiramo === "N" || selectedNode.elemento.extra_fields.nascondidest === "N" || selectedNode.elemento.extra_fields.nascondilink === "N");
    }

    /**
     * funzione che serve per capire se un nodo di tipo faq è configurato come "visibile"
     * @param {*} item 
     * @param {*} elemento_padre_id 
     * @returns 
     */
    const isFaqVisible = (item, elemento_padre_id) => {

        var ret = item.elemento_padre_id == elemento_padre_id && item.elemento.extra_fields.nascondifaq == 'N';
        if (!ret) {
            return ret;
        }

        if (item.elemento.extra_fields.open_dt != null) {
            ret = ret && moment(item.elemento.extra_fields.open_dt).isBefore(moment());
            if (!ret) {
                return ret;
            }
        }

        if (item.elemento.extra_fields.close_dt != null) {
            ret = ret && moment(item.elemento.extra_fields.close_dt).isAfter(moment());
            if (!ret) {
                return ret;
            }
        }

        return ret;

    }

    /**
     * funzione che serve per capire se un nodo di tipo faq è configurato come "visibile"
     * @param {*} item 
     * @param {*} elemento_padre_id 
     * @returns 
     */
    const isDest = (item, elemento_padre_id) => {

        var ret = item.elemento_padre_id == elemento_padre_id && item.elemento.extra_fields.nascondidest == 'N';
        if (!ret) {
            return ret;
        }
        return ret;

    }

    /**
     * funzione che serve per caricare le sole faq visibili
     * @param {*} elemento_padre_id 
     */
    const caricaFaqs = (elemento_padre_id) => {
        setLoading(true)
        setFaqs(null)
        PJAxios().get('/chatbot/loadFaqs/' + elemento_padre_id).then((res) => {
            setFaqs(res.data.items)
            setLoading(false)
        });
    }

    /**
     * funzione che serve per caricare le sole faq visibili
     * @param {*} elemento_padre_id 
     */
    const caricaDest = (elemento_padre_id) => {
        PJAxios().get('/chatbot/loadDests/' + elemento_padre_id).then((res) => {
            setDests(res.data.items)
            console.log("DEST ---> ", res);
        });
    }

    /**
     * gestione variabili in caso di "torna all'inizio"
     */
    const handleRootClick = () => {

        setLevel("root")
        setAlbero(alberoRoot)
        setArgumentz([])
        setSelectedArgument(null)
        setSelectedMenu(null)
        setFaqDetail(null)
        setSelectedFaq(null)
        setTextChangeTrigger(textChangeTrigger + 1)
        setIdParent(null)
    }

    /**
     * header template per fare in modo che non si veda quello dell'editor testuale
     * @returns 
     */
    const getHeaderTemplate = () => {
        return <div className='surface-card' style={{ height: "0px" }}></div>
    }

    const caricaListaEventiComplessivi = () => {
        try {
            PJAxios().post('/chatbot/listaEventiComplessivi').then((res) => {
                setTematicheNoChat(res.data);
            });
        } catch (e) {
            console.error("errore in caricaListaEventiComplessivi")
        }


    }

    /**
     * funzione che fa le chiamate per recuperare le informazioni dell'albero
     * @param {*} id_config 
     */
    const caricaConfigurazioni = (id_config, level) => {
        //console.log("carica configurazioni", id_config, level)
        setLoading(true)

        caricaListaEventiComplessivi()

        if (level == 'root') {
            PJAxios().post('/chatbot/loadRoot', { idConfig: id_config }).then((res) => {
                setMenus(res.data.items)
            });

        } else if (level == 'menu') {
            PJAxios().post('/chatbot/loadSubroot', { idConfig: id_config }).then((res) => {
                setArgumentz(res.data.items)
            });
        }



        PJAxios().post('/chatbot/modificaConfigurazioni', { idConfig: id_config }).then((res) => {
            //toast.current.show({ severity: 'info', detail: getText("BOT_WELCOME"),life: 5000  });
            setAlbero(res.data.strutturaAlbero.albero)

            if (id_config != 48) {
                PJAxios().post('/chatbot/listaEventi', { idConfig: id_config }).then((res) => {
                    setEventi(res.data);
                });
            }

            if (id_config == 48 || id_config == 114 || id_config == 120) {
                setAlberoRoot(res.data.strutturaAlbero.albero)
                PJAxios().get('/chatbot/getSubtreeFaqs/' + id_config).then((res) => {
                    setFaqIds(res.data.ids);
                    setAutoCompleteFaqs(configureTree(res.data.strutturaAlbero.albero_faq));
                })
            }

            if (storedMenu && !selectedMenu) {
                setSelectedMenu(JSON.parse(storedMenu));
                sessionStorage.removeItem("selectedMenu");
                if (storedArgument && !selectedArgument) {
                    setSelectedArgument(JSON.parse(storedArgument));
                    sessionStorage.removeItem("selectedArgument");
                }
            }

        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: getText("ERROR_LOADING_CONTENTS"), detail: getText("ERROR_LOADING_CONTENTS"), life: 10000 });
            console.error(err);
        }).finally(() => {
            setLoading(false);
        });

    }



    useEffect(() => {
        setOtoboEnabled(true);
        if (eventi != null && eventi.length > 0) {
            var millis = new Date().getTime()
            var daysOfWeek = new Date().getDay()

            eventi.forEach((evento) => {

                if (evento.periodicita == "S") {
                    if (sonoNelRange(evento.data_info, evento.data_fine)) {
                        setEventoDiInformazione(evento);
                        //console.log("SEI NELL'INFO");
                    }

                    if (sonoNelRange(evento.data_inizio, evento.data_fine)) {
                        if (evento.disattiva_dest == "S") {
                            setOtoboEnabled(false);
                            setEventoDiChiusura(evento);
                        } else {
                            infoMessages.push(evento)
                        }
                    }
                }


                if (millis >= evento.data_info && millis <= evento.data_fine) {
                    setEventoDiInformazione(evento)
                }
                if (millis >= evento.data_inizio && millis <= evento.data_fine) {
                    if (evento.disattiva_dest == "S") {
                        setOtoboEnabled(false);
                        setEventoDiChiusura(evento)
                    } else {
                        infoMessages.push(evento)
                    }

                }
            })
        }
    }, [eventi]);

    function sonoNelRange(dataInizio, dataFine) {
        const oggi = new Date();
        const realStarting = new Date(dataInizio);

        if (oggi < realStarting)
            return false;
        const starting = giornoInQuestaSettimana(realStarting);
        const ending = giornoDellaSettimanaDopo(starting, new Date(dataFine));
        const startingSettimanaPrima = giornoNellaSettimanaPrima(realStarting);
        const endingSettimanaPrima = giornoDellaSettimanaDopo(startingSettimanaPrima, new Date(dataFine));


        return (oggi >= starting && oggi <= ending || oggi >= startingSettimanaPrima && oggi <= endingSettimanaPrima);
    }

    function giornoNellaSettimanaPrima(date) {
        const dayOfWeek = date.getDay();
        const today = new Date();


        const startOfWeek = new Date(today.setDate(today.getDate() - 7 - today.getDay() + 1));// Lunedì della settimana corrente
        const currentWeekDay = new Date(startOfWeek);
        currentWeekDay.setDate(startOfWeek.getDate() + dayOfWeek - 1);

        currentWeekDay.setHours(date.getHours());
        currentWeekDay.setMinutes(date.getMinutes());
        currentWeekDay.setSeconds(date.getSeconds());
        currentWeekDay.setMilliseconds(date.getMilliseconds());

        return currentWeekDay;
    }

    function giornoInQuestaSettimana(date) {
        const dayOfWeek = date.getDay();
        const today = new Date();


        const startOfWeek = new Date(today.setDate(today.getDate() - today.getDay() + 1));// Lunedì della settimana corrente
        const currentWeekDay = new Date(startOfWeek);
        currentWeekDay.setDate(startOfWeek.getDate() + dayOfWeek - 1);

        currentWeekDay.setHours(date.getHours());
        currentWeekDay.setMinutes(date.getMinutes());
        currentWeekDay.setSeconds(date.getSeconds());
        currentWeekDay.setMilliseconds(date.getMilliseconds());

        return currentWeekDay;
    }

    function giornoDellaSettimanaDopo(startDate, targetDate) {
        const targetDayOfWeek = targetDate.getDay();
        const startDayOfWeek = startDate.getDay();
        const daysUntilNextTarget = (7 - startDayOfWeek + targetDayOfWeek) % 7 || 7;

        const nextTargetDate = new Date(startDate);
        nextTargetDate.setDate(startDate.getDate() + daysUntilNextTarget);

        nextTargetDate.setHours(targetDate.getHours());
        nextTargetDate.setMinutes(targetDate.getMinutes());
        nextTargetDate.setSeconds(targetDate.getSeconds());
        nextTargetDate.setMilliseconds(targetDate.getMilliseconds());

        return nextTargetDate;
    }

    useEffect(() => {
        if (eventoDiChiusura != null || eventoDiInformazione != null) {
            setShowHolidayDialog(true)
        }
    }, [eventoDiChiusura, eventoDiInformazione]);

    /**
     * funzione che serve per mostrare l'icona giusta a seconda del tipo di ramo
     * @param {*} item 
     * @returns 
     */
    const getIcon = (item) => {

        if (item.elemento.elemento_fltp === "M") {
            return "pi pi-folder";
        } else if (item.elemento.elemento_fltp === "S") {
            if (item.elemento.extra_fields.email != null) {
                return "pi pi-envelope";
            } else if (item.elemento.extra_fields.domanda_en != null) {
                return "pi pi-question-circle";
            } else if (item.elemento.extra_fields.tema_collegato != null) {
                return "pi pi-link";
            }
        }
    }

    /**
     * conversione dell'albero in struttura gestibile dall'oggetto "tree" (serve di + lato configurazione ma abbiamo ereditata, quindi ok)
     * @param {*} tree 
     * @param {*} rootId 
     * @returns 
     */
    const configureTree = (tree, rootId) => {
        let nodes = [];

        let radice = {
            key: tree.radice.elemento_id,
            label: tree.radice.albero_dn,
            icon: "pi pi-sitemap",
            data: tree.radice,
            children: [],
            root: true
        }

        tree.listaCompletaRami.forEach((ramoItem) => {
            var icon = getIcon(ramoItem);


            //var label = ramoItem.elemento.extra_fields.bundle != null ? ramoItem.elemento.extra_fields.bundle : ramoItem.elemento.extra_fields.titolo;
            var label = ramoItem.elemento.extra_fields.bundle != null ? ramoItem.elemento.extra_fields.bundle : ramoItem.elemento.extra_fields.titolo;
            if (label.length > 100) {
                label = label.slice(0, 100) + "...";
            }

            var ramo = {
                key: ramoItem.elemento_id,
                label: label,
                icon: icon,
                data: ramoItem,
                children: []

            }

            tree.listaCompletaFoglie.forEach((fogliaItem) => {
                icon = getIcon(fogliaItem);

                var labelSuffix = "";
                if (fogliaItem.elemento.extra_fields.open_dt != null && fogliaItem.elemento.extra_fields.close_dt != null) {
                    labelSuffix = " (" + moment(fogliaItem.elemento.extra_fields.open_dt).format("DD-MM-YYYY") + " a " + moment(fogliaItem.elemento.extra_fields.close_dt).format("DD-MM-YYYY") + ")";
                }

                var labelF = fogliaItem.elemento.extra_fields.titolo;
                if (labelF.length > 100) {
                    labelF = labelF.slice(0, 100) + "...";
                }


                var foglia = {
                    key: fogliaItem.elemento_id,
                    label: labelF + labelSuffix,
                    icon: icon,
                    data: fogliaItem,
                    children: []
                }

                if (fogliaItem.elemento_padre_id === ramoItem.elemento_id) {
                    ramo.children.push(foglia);
                }
            })

            if (ramoItem.elemento_padre_id === radice.data.elemento_id) {
                ramo.id_item_parent = tree.radice.extra_fields.id_item
                radice.children.push(ramo);
            } else {
                radice.children.forEach((radiceChilds) => {
                    if (ramoItem.elemento_padre_id === radiceChilds.key) {
                        try {
                            ramo.id_item_parent = radiceChilds.elemento.extra_fields.id_item
                            radiceChilds.children.push(ramo);
                        } catch (exception) {
                            //console.log(radiceChilds.elemento);
                        }
                    }
                })
            }
        })

        nodes.push(radice)
        return nodes;
    }

    /**
     * funzione che serve per staccare nuovo id conversazione
     */
    const createNewConversation = () => {

        PJAxios().get('/chatbot/createNewConversation').then((res) => {
            setConversationId(res.data)
        }).catch((e) => {
            //console.log(e)
        })
    }

    const beginConversation = (conversationId, codice_persona, language) => {
        PJAxios().post('/chatbotReport/beginConversation', { conversationId, codice_persona, language }).then((res) => {

        })
    }

    const endConversation = (conversationId, codice_persona, language) => {
        PJAxios().post('/chatbotReport/endConversation', { conversationId }).then((res) => {

        })
    }

    const addRigaConversation = (conversationId, iUtenteTxt, iTematicaDn, iArgomentoDn, iFaqId, iCanaleFltp) => {
        let request = { conversationId, iUtenteTxt, iTematicaDn, iArgomentoDn, iFaqId, iCanaleFltp }
        PJAxios().post('/chatbotReport/addRigaConversation', request).then((res) => { })
    }

    const onExternalJump = (iCanaleFltp) => {

        if (conversationId != null) {
            addRigaConversation(
                conversationId,
                searchText,
                selectedMenu != null ? selectedMenu.idItem : null,
                selectedArgument != null ? selectedArgument.idItem : null,
                selectedFaq != null ? selectedFaq.idItem : null,
                iCanaleFltp)
        }
    }

    /**
     * all'ingresso in pagina caricare albero root e staccare id conversazione
     */

    useEffect(() => {

        let idConfig = sessionStorage.getItem("idConfig") != null ? sessionStorage.getItem("idConfig") : 48;

        document.title = "Contatti per gli studenti";

        if (props.idConfig != null) {
            idConfig = props.idConfig
            if (idConfig == 120) {
                document.title = "Assistenza Dottorandi";
            }
        } else if (props.match.params.idConfig != null) {
            idConfig = props.match.params.idConfig
            let chatbot = props.match.params.chatbot
            if (idConfig == 114) {
                if (!isLogged) {
                    sendLogin()
                } else {

                }

                document.title = "Faq Personale";
            }
        }
        setIdConfig(idConfig)


    }, []);



    const loadExternalSources = (idNode, idTematica) => {
        PJAxios().post('/chatbot/getExternalSources', { idNode: idNode != null ? idNode : - idTematica, extSource: "" }).then((res) => {
            setExternalSources(res.data);
            setLoading(false);
        });
    }

    /**
     * nel momento in cui si seleziona la tematica ne viene caricato il suo albero
     */
    useEffect(() => {
        try {
            if (selectedMenu != null) {
                setIdConfig(idConfig);
                if (selectedArgument == null) {//aggiunto per tornare al nodo quando facciamo il Login(non impatta il giro normale)
                    setLevel("menu");
                }
                caricaConfigurazioni(selectedMenu.tematica, "menu");
                addRigaConversation(conversationId, searchText, selectedMenu.id_item, null, null);

                loadExternalSources(null, selectedMenu.tematica);
                setIdParent(null);
                setPreviousMenu(selectedMenu);
            }
        } catch (error) {
            console.error("Error in useEffect selectedMenu:", error);
        }
    }, [selectedMenu]);

    const getExternalContactLinks = (idNode) => {
        setChannels(null)
        PJAxios().post('/chatbot/getExternalContactLinks', { idNode: idNode }).then((res) => {
            setChannels(res.data.channels);
            setLoading(false)
        })
    }

    /**
     * nel momento in cui viene selezionata la faq ne viene caricato il suo dettaglio completo (compresi i link alle chat e appuntamento)
     */
    useEffect(() => {
        try {
            if (selectedFaq != null) {
                var url = '/chatbot/getItemDetail/' + selectedFaq.idItem;
                PJAxios().get(url).then((res) => {
                    setFaqDetail(res.data);
                });

                setIdParent(null);

                if (level == 'faqSearch') {
                    PJAxios().get('/chatbot/getNodeParentFromIdItem/' + selectedFaq.idItem).then((res) => {
                        caricaDest(res.data.idArgomento);
                        setIdParent(res.data);
                        if (res.data.idConfig != 48) {
                            PJAxios().post('/chatbot/listaEventi', { idConfig: res.data.idConfig }).then((res) => {
                                setEventi(res.data);
                            });
                        }

                        setLoading(false);
                        getExternalContactLinks(res.data.idArgomento);
                    });
                }
                addRigaConversation(
                    conversationId,
                    searchText,
                    selectedMenu != null ? selectedMenu.id_item : null,
                    selectedArgument != null ? selectedArgument.id_item : null,
                    selectedFaq != null ? selectedFaq.id_item : null,
                    null
                );
            }
            else {
                if (level == 'faqSearch') {
                    setChannels(null)
                }
            }
        } catch (error) {
            console.error("Error in useEffect selectedFaq:", error);
        }
    }, [selectedFaq]);

    /**
     * quando si cambia il testo di ricerca vengono aggiornati i risultati
     */
    useEffect(() => {
        if (searchText != null && searchText.length > 0) {
            setSelectedFaq(null)
            setChannels(null)
            setLevel("faqSearch")
            searchNode(searchText)
        } else {
            setLevel("root")
            setClearTextTrigger(clearTextTrigger + 1)
        }
    }, [searchText]);

    const openLinkQuestionario = () => {
        if (!conversationId) return;
        setLoading(true)
        PJAxios().get('/chatbot/getUrlSalto/1453').then((res) => {
            var tampering = Buffer.from(sha256("-" + conversationId  + "-ch9753SSdf0")).toString('base64')
            if (tampering.endsWith("==")) {
                tampering = tampering.replace("==", "");
            }
            var url = res.data + "&spazio=-&conversazione=" + conversationId  + "&turno=-&tampering=" + tampering;

            window.open(url, '_blank', 'noreferrer')
            setLoading(false)
        })
    }

    /**
     * quando viene caricata la lista intera di oggetti dell'albero, vengono prese in cosiderazione solo quelle attive
     */
    useEffect(() => {
        let questions = [];

        if (autoCompleteFaqs != null) {
            autoCompleteFaqs[0].children.forEach((faq) => {
                if (faq.icon === "pi pi-question-circle") {
                    if (faq.data.elemento.extra_fields.numero_istanze > 0) {
                        let question = {
                            value: faq.key,
                            label: "" + faq.label,
                            icon: faq.icon,
                            data: faq.data
                        }
                        questions.push(question);
                    }

                } else if (faq.icon === "pi pi-folder") {

                    faq.children.forEach((inner) => {
                        if (inner.icon === "pi pi-question-circle") {
                            if (inner.data.elemento.extra_fields.numero_istanze > 0) {
                                let question = {
                                    value: inner.key,
                                    label: inner.label,
                                    icon: inner.icon,
                                    data: inner.data
                                }
                                questions.push(question);
                            }

                        }
                    })
                }

            })
        }
        setQuestions(questions);

    }, [autoCompleteFaqs]);


    /**
     * quando viene caricato l'albero da db si popola l'oggetto corretto, a seconda che siano argomenti (sottoalbero) o tematiche (albero-root)
     */
    useEffect(() => {
        var items = []
        try {

            albero.struttura.map((item) => {
                if (item.elemento_padre_id == 0 && isNodeVisible(item)) {
                    items.push(item);
                }
                if (level == 'root') {
                    //setMenus(items);

                    if (sottoTematiche == null) {
                        var ret = []
                        albero.listaCompletaFoglie.forEach((foglia) => {
                            if (foglia.elemento.extra_fields.type == 'L') {
                                ret.push({
                                    id_config: foglia.elemento.extra_fields.tema_collegato.split(" - ")[0],
                                    titolo: foglia.elemento.extra_fields.titolo,
                                    descrizione: foglia.elemento.extra_fields.descrizione,
                                    quantita: foglia.elemento.extra_fields.quantita,
                                })
                            }

                            setSottoTematiche(ret);
                        })

                    }

                } else {
                    //setArgumentz(items)
                }


            })
        } catch (e) {

        }
    }, [albero]);

    const chipT = (
        <span className="font-medium" >{getText("MAIL_CHAT_UNAVAILABLE")}</span>
    );

    /**
     * template di navigazione della row con la freccetta
     */
    const rowTemplate = (rowData) => {
        return (
            <div className="formgroup-inline col-12 md:col-12 lg:col-12">
                <>
                    {selectedFaq &&
                        <div className="col-12 md:col-12" style={{ height: "35%" }}>
                            <div className="col-12 md:col-12 " dangerouslySetInnerHTML={{ __html: getText(getConventionalAnswer(selectedFaq)) }}>
                            </div>

                        </div>
                    }
                </>
            </div >

        );
    }

    const cardClick = (event, data) => {
        event.stopPropagation();
        //console.log("DATOOOOOO:  ", data)
        {
            !selectedMenu &&
                setSelectedMenu(data);
        }
        {
            selectedMenu &&
                setSelectedArgument(data);
        }
    };

    const cardTemplate = (rowData) => {
        return (
            <div className="formgroup-inline col-12 md:col-6 lg:col-6" style={{ padding: "0.1em" }}>
                <Card
                    className='pj-bg-white-special'
                    style={{
                        minHeight: "100px",
                        width: "100%",
                        height: "100%",
                        cursor: "pointer",
                        display: "flex", // AGGIUNTO: per gestire meglio l'altezza
                        flexDirection: "column",
                        justifyContent: "space-between",
                        flexGrow: 1  // MODIFICATO: per far espandere la card alla stessa altezza
                    }}
                    onClick={(e) => cardClick(e, rowData)}
                >
                    <div className="m-0 col-11" style={{
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        flexGrow: 1 // AGGIUNTO: per occupare tutto lo spazio disponibile
                    }}>
                        {!selectedMenu && (
                            <div style={{ flexGrow: 1 }}>
                                <h4 className="pj-text-primary-accent-light">{getText(getNome(rowData))}</h4>
                                <p className='pj-text-p2' style={{ width: "100%" }}>{getText(getDescrizione(rowData)).startsWith("[") ? "" : getText(getDescrizione(rowData))}</p>
                            </div>
                        )}
                        {selectedMenu && (
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    height: "100%",
                                    flexGrow: 1
                                }}>
                                <div>
                                    <h4 className="pj-text-primary-accent-light" style={{ width: "100%", height: "100%" }}>{getText(getNome(rowData))}</h4>
                                    <p className='pj-text-p2' style={{ width: "100%", height: "40px" }}>
                                        {getText(getDescrizione(rowData)).startsWith("[") ? "" : getText(getDescrizione(rowData))}
                                    </p>
                                </div>
                                <div>
                                    <Divider />
                                    <p className='pj-text-small pj-text-disabled'>
                                        <strong className='pj-text-small-bold'>{getQuantitaDomande(rowData)}</strong> domande frequenti
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </Card>
            </div>

        );
    }

    /**
     * gestione del click sul pulsante back arrow
     */
    const handleBackClick = () => {
        if (level == 'menu') {
            setLevel("root")
            setArgumentz([])
            setSelectedMenu(null)
        } else if (level == 'faq') {
            setLevel('menu')
            setSelectedArgument(null)

        } else if (level == 'faqSearch' && searchText.length > 0) {

            if (emptyResultSearch != null) {
                /*addRigaConversation(conversationId, emptyResultSearch,
                    "EMPTY_RESULT",
                    null,
                    null,
                    false, true, false, null, null, null)*/
                setEmptyResultSearch(null)
            }


            setTextChangeTrigger(textChangeTrigger + 1)

            setSearchText('')
        } else if (level == 'faqDetail') {
            if (selectedArgument != null) {
                setLevel('faq')
            } else {
                setLevel("faqSearch")
                searchNode(searchText)
            }

            setSelectedFaq(null)
            setFaqDetail(null)
        }
    }

    const openLinkByValue = (valore) => {
        onExternalJump("W")
        window.open(valore, '_blank', 'noreferrer')
    }

    /**
     * template di ricerca faq
     * @param {*} rowData 
     * @returns 
     */
    const faqResultTemplate = (rowData) => {
        return (
            <div className="formgroup-inline col-12 md:col-12 lg:col-12">
                {selectedFaq &&
                    <div className="col-12 md:col-12" style={{ height: "35%" }}>
                        <div className="col-12 md:col-12 " dangerouslySetInnerHTML={{ __html: getText(getConventionalAnswer(selectedFaq)) }}>
                        </div>

                    </div>
                }
            </div >


        );
    }


    /**
     * funzione che valorizza il titolo sulla base del livello scelto
     * @returns 
     */
    const getPreTitle = () => {
        if (level == 'root') {
            return capitalizeFirstLetter(getText("FAQ_AND_SUPPORT_" + idConfig))
        } else if (level == 'menu') {
            return capitalizeFirstLetter(getText("CHOOSE_ARGUMENT"))
        } else if (level == 'faq') {
            return capitalizeFirstLetter(getText(getNome(selectedMenu)))
        } else if (level == 'faqSearch') {
            return capitalizeFirstLetter(getText("LBL_RESULT_PRETITLE"))
        } else if (selectedFaq != null) {
            return capitalizeFirstLetter(getText("ANSWER"))
        }
    }


    //funzione che crea la stringa con la sola iniziale maiuscola
    function capitalizeFirstLetter(input) {
        if (!input) return '';
        const lower = input.toLowerCase();
        return lower.charAt(0).toUpperCase() + lower.slice(1);
    }



    /**
     * funzione che valorizza il titolo sulla base del livello scelto
     * @returns 
     */
    const getTitle = () => {
        if (level == 'root') {
            return capitalizeFirstLetter(getText("CHOOSE_TOPIC"))
        } else if (level == 'menu') {
            return capitalizeFirstLetter(getText(getNome(selectedMenu)))
        } else if (level == 'faq') {
            return capitalizeFirstLetter(getText(getNome(selectedArgument)))
        } else if (level == 'faqSearch') {
            return capitalizeFirstLetter(getText("LBL_RESULT"))
        } else if (selectedFaq != null) {
            return capitalizeFirstLetter(getText("ANSWER"))
        }
    }

    /**
     * funzione che valorizza il titolo sulla base del livello scelto
     * @returns 
     */
    const getSubTitle = () => {
        if (level == 'root') {
            return null
        } else if (level == 'menu') {
            return capitalizeFirstLetter(getText(getDescrizione(selectedMenu)).startsWith("[") ? "" : getText(getDescrizione(selectedMenu)))
        } else if (level == 'faq') {
            if (idConfig == 120) {
                return capitalizeFirstLetter(getText("DOTTORANDI_TUTORIAL_FAQ"))
            }
            return capitalizeFirstLetter(getText(getDescrizione(selectedArgument)).startsWith("[") ? "" : getText(getDescrizione(selectedArgument)))
        } else if (level == 'faqSearch') {
            return null
        } else if (selectedFaq != null) {
            return capitalizeFirstLetter(getText("ANSWER"))
        }
    }

    /**
     * messaggio che sta dentro il chip nel dettaglio faq
     * @returns 
     */
    const getInfoMessage = () => {
        if (faqDetail != null) {
            var message = "";
            var title = "";
            if (selectedFaq.elemento.extra_fields.numero_usi + selectedFaq.elemento.extra_fields.numero_istanze > 0) {
                title = getText("TEMATICHE_PRESENZA_ITEM") + ": ";
                faqDetail.tematiche.forEach((tematica, index) => {
                    message = message + '"' + tematica.name + '",\n';
                })
                message = message.substring(0, message.length - 2);
            }
            return (<div>
                <p>{title}</p>
                <p style={{ textAlign: "left" }}>{message}</p>
            </div>);
        } else {
            return "";
        }

    }

    /**
     * trigger dell'evento di change della searchbox
     * @param {*} text 
     */
    const onSearchBoxTextChanged = (text) => {
        setSearchText(text);
    }


    const chipTemplate = () => {
        return (
            <div style={{ display: 'inline-flex' }} >
                <div style={{ padding: "7px" }}>
                    <i className="pi pi-info-circle" style={{ fontSize: '1rem', color: '#995c00' }}></i>
                </div>
                {eventoDiInformazione != null && eventoDiChiusura === null &&
                    <div style={{ marginLeft: "10px" }}>
                        <h3>Gli uffici saranno chiusi</h3>
                        <div style={{ paddingTop: "7px" }} dangerouslySetInnerHTML={{ __html: getText(eventoDiInformazione.bundle_messaggio) }} />
                    </div>
                }
                {eventoDiChiusura != null &&
                    <div style={{ marginLeft: "10px" }}>
                        <h3>Gli uffici sono chiusi</h3>
                        <div style={{ paddingTop: "7px" }} dangerouslySetInnerHTML={{ __html: getText(eventoDiChiusura.bundle_messaggio) }} />
                    </div>
                }
            </div>
        )
    }

    const handleToggle = (element) => {
        if (selectedFaq && selectedFaq.idItem === element) {
            setSelectedFaq(null); // Chiude il tab se è già aperto
        } else {
            setSelectedFaq(element); // Altrimenti lo apre
        }
    };




    return (

        <div className='main' >
            <Toast ref={toast}></Toast>
            
            {!loading &&
                <div className={selectedFaq != null ? "surface-card" : "bg-primary"}>
                    <BackArrow handleBackClick={handleBackClick} />


                    <div className='gridWithSearch formgroup-inline'>


                        <div className='noborder col-12 md:col-9 lg:col-9' >
                            <div className="col-12 md:col-12">
                                <div className="col-12 md:col-12">

                                    <p className='pj-text-pretitle pj-text-primary-accent-light'>{getPreTitle()}</p>
                                    <h1 >{getTitle()}</h1>
                                    <p className='pj-text-p2' >{getSubTitle()}</p>

                                    {level === 'root' && (() => {
                                      const dynamicKey = 'BOT_WELCOME_' + idConfig;
                                      let welcome = getText(dynamicKey);
                                      return welcome.startsWith("[") ? getText('BOT_WELCOME') : welcome;
                                    })()}

                                </div>
                            </div>
                            {level == 'root' &&
                                <>
                                    <DataView style={{ width: "100%" }} itemTemplate={cardTemplate} value={menus} />
                                </>


                            }

                            {level == 'menu' && argumentz != null && argumentz.length > 0 &&
                                <>
                                    <DataView style={{ width: "100%" }} itemTemplate={cardTemplate} value={argumentz} />

                                    {externalSources != null && externalSources.length > 0 &&
                                        <>
                                            <div className="formgroup-inline">
                                                <div className='col-4'>
                                                    &nbsp;
                                                </div>
                                                <div className='col-4'>
                                                    <Divider />
                                                </div>
                                                <div className='col-4'>
                                                    &nbsp;
                                                </div>
                                            </div>

                                            <div className="surface-hover col-12 md:col-12" style={{ padding: "2px", textAlign: "left", height: "30%" }}>
                                                < div className=" col-12 md:col-12 lg:col-12">
                                                    <div className=" col-12 md:col-12 lg:col-12" style={{ padding: "2px" }}>
                                                        <Button icon="pi pi-link" onClick={() => openLinkByValue(externalSources[0].EXT_SOURCE)}
                                                            className="p-button-text"
                                                            label={<div style={{ textDecorationLine: 'underline', textTransform: "uppercase" }}>{getText("LINK_PER_MAGGIORI_INFORMAZIONI")}</div>} />

                                                    </div>
                                                </div>

                                            </div>
                                        </>
                                    }
                                </>
                            }

                            {level == 'faq' &&
                                <>
                                    <div className="col-12 md:col-12">
                                        <div className="col-12 md:col-12" style={{ textAlign: "left", textTransform: "uppercase" }}>
                                            <b>{getText("READ_FAQS")} </b>
                                        </div>
                                    </div>

                                    <Accordion activeIndex={selectedFaq ? (faqs || []).findIndex(faq => faq.idNode === selectedFaq.idNode) : null} onTabChange={(e) => handleToggle(faqs[e.index])}>
                                        {(faqs || []).map((faq) => (
                                            <AccordionTab key={faq.idNode} header={getText(faq.question)}>
                                                {rowTemplate(faq)}
                                            </AccordionTab>
                                        ))}
                                    </Accordion>
                                    <BackBottomButton handleRootClick={handleRootClick} />
                                </>


                            }

                            {level == 'faqSearch' &&
                                <>
                                    <Accordion activeIndex={selectedFaq ? faqResults.findIndex(faq => faq.idNode === selectedFaq.idNode) : null} onTabChange={(e) => handleToggle(faqResults[e.index])}>
                                        {(faqResults || []).map((faq) => (
                                            <AccordionTab key={faq.idNode} header={getText(faq.question)}>
                                                {faqResultTemplate(faq)}
                                            </AccordionTab>
                                        ))}
                                    </Accordion>
                                </>
                            }


                            {level == 'faqSearch' &&
                                <BackBottomButton handleRootClick={handleRootClick} />
                            }
                        </div>
                        <div className=' col-12 md:col-3 lg:col-3'>
                            {level == 'faq' && showHolidayDialog == true &&
                                <div>
                                    <Card className='pj-bg-white-special' style={{ borderLeft: "solid 6px #995c00", marginBottom: "10px" }}>
                                        {chipTemplate()}
                                    </Card>
                                </div>
                            }



                            <Card className='pj-bg-primary-light'>
                                {level != 'root' &&
                                    <ContactChannels idConfig={idConfig} dests={dests} idParent={idParent} faqResults={faqResults} otoboEnabled={otoboEnabled} conversationId={conversationId} onExternalJump={onExternalJump} level={level} selectedFaq={selectedFaq} channels={channels} selectedArgument={selectedArgument} selectedMenu={selectedMenu} previousArgument={previousArgument} previousMenu={previousMenu} />
                                }
                                <SearchBox clearTextTrigger={clearTextTrigger} textChangeTrigger={textChangeTrigger} searchText={searchText} onTextChanged={onSearchBoxTextChanged} />
                            </Card>

                            <div style={{ display: 'inline-flex', alignContent: 'center' }} >
                                <div style={{ paddingTop: '24px', display: 'flex', alignItems: 'center' }}>
                                    <h3>Valuta questo servizio</h3>
                                </div>
                                <div style={{ paddingTop: '24px', alignContent: 'center' }} >
                                    <PJButton onClick={() => openLinkQuestionario()} icon="pmi-line pmi-12 pmi-line-arrow-right" className='p-button-text' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            }
            {loading && <ProgressSpinner />}


        </div >
    )
}

export default ChatbotRestyled
